export default defineNuxtPlugin((nuxtApp) => {
    const sendAnalyticsEvent = (params: {
        event: 'event' | 'goal'
        page: string
        action: 'click' | 'open' | 'send' | 'start' | 'done'
        position: string
        content: string
        context?: string
        source?: string
        clinicId?: number
    }) => {
        if (typeof window !== 'undefined') {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push(params)
        }
    }

    const analyticsDirective = {
        mounted(el: HTMLElement, binding: any) {
            el.addEventListener('click', () => {
                const url = window.location.pathname
                let page = 'main'

                if (url.startsWith('/clinics/')) page = 'clinics'
                else if (url.startsWith('/veterinars/')) page = 'veterinarians'
                else if (url.startsWith('/veterinars/online/')) page = 'veterinarians-online'
                else if (url.startsWith('/blog/')) page = 'blog'
                else if (url.startsWith('/uslugi/')) page = 'services'
                else if (url.startsWith('/veterinar-rating/')) page = 'leaderboard'


                const defaultParams = {
                    event: 'event',
                    action: 'click',
                    page,
                    position: binding.arg || 'unknown',
                    content: el.textContent?.trim() || el.innerText?.trim() || el.getAttribute('aria-label') || 'unknown',
                }

                const params = typeof binding.value === 'object'
                    ? { ...defaultParams, ...binding.value }
                    : defaultParams

                sendAnalyticsEvent(params)
            })
        },
        getSSRProps (binding, vnode) {
            return {}
        }
    }

    nuxtApp.vueApp.directive('analytics', analyticsDirective)

    return {
        provide: {
            analytics: sendAnalyticsEvent
        }
    }
})